let Constant = /** @class */ (() => {
    class Constant {
    }
    Constant.AssetStatus = class {
        static Assigned() {
            return "C1DB51DB-EA97-4A06-91C4-1061A770D1BC".toLowerCase();
        }
        static Disposed() {
            return "A955DDF9-2ED6-44DE-A8EF-532C88E4F761".toLowerCase();
        }
        static Repair() {
            return "4A5D53C5-C19C-4952-9750-802F2BF5CB93".toLowerCase();
        }
        static InStore() {
            return "891DFBF9-2147-4210-8032-906CEE709E90".toLowerCase();
        }
        static Scrap() {
            return "A437A049-72AE-43B9-8DD3-E506B78134D0".toLowerCase();
        }
    };
    Constant.Providers = class {
        static ZohoHrmsProvider() {
            return "4E16DE0B-9909-4F14-86FD-2F68076415AF".toLowerCase();
        }
        static EmptyHrmsProvider() {
            return "F0E6C8AF-3D80-480A-8B4D-A37395183F1B".toLowerCase();
        }
        static EmptyCalendarIntegrationProvider() {
            return "25530B87-9CF3-42A5-B06A-88021FA7AC3A".toLowerCase();
        }
        static GoogleCalendarIntegrationProvider() {
            return "070B9B58-5EA7-436A-B29F-3A1AAAFC5B0C".toLowerCase();
        }
    };
    Constant.ExternalApiTypes = class {
        static Shift() {
            return "E46A877A-7187-4797-AAF3-C17E54D63208".toLowerCase();
        }
        static ReportingTo() {
            return "972DB488-F5AD-44C4-B3B0-7CAA87071D61".toLowerCase();
        }
        static Designations() {
            return "D6B87B93-EEBE-4FF7-8E7C-4A77D8479651".toLowerCase();
        }
    };
    Constant.TargetAudiences = class {
        static ReportingTo() {
            return "562fda4e-c29d-4188-8722-a2ecf1f1b7ae";
        }
        static Client() {
            return "a06bf6c4-f0ed-43e3-a181-36c80a4b4838";
        }
    };
    Constant.NotificationTypes = class {
        static SubProjectRequestId() {
            return "f305eb8b-22e9-4a3c-9da2-a6216fdd093b";
        }
        static AddProjectTeamMemberNotificationId() {
            return "8e0383da-a5be-4433-b234-8325d79d2c60";
        }
        static ChangeOwnerShipNotificationId() {
            return "ab1077bf-188e-4e52-9788-ae78db8f8b98";
        }
        static AcceptedLinkedProjectNotificationId() {
            return "f5ff4414-9ed3-45b8-bb02-1eac00b2a80e";
        }
        static ConvertTaskToProjectNotificationId() {
            return "bbf450b5-da50-4a94-95d0-84ba2df04d77";
        }
        static ReviewNotification() {
            return "515a0cc7-dd2e-4765-a1cb-ae7884195ac5";
        }
        static ReviewMeetingNotification() {
            return "3ae19806-9b0c-4641-aa15-ea49f5d7e3bc";
        }
        static RequestedProjectRejectionNotification() {
            return "d2bbcb1d-90ac-4ddc-91ea-e17dcf0dfe9d";
        }
        static HostileTakeOverNotification() {
            return "9237e438-8cd4-4b3a-b81a-873339e672a8";
        }
    };
    return Constant;
})();
export { Constant };
